<template>
  <iframe :id="iframeId" :src="iframeUrl" frameborder="0" ref="iframeref" name="iframeWrapper"></iframe>
</template>

<script>

export default {
  name: 'iframe-wrapper',
  props: {
    iframeId: String,
    iframeUrl: String
  },
  data() {
    return {
        sendUpdatesToChild: false,
        savedEvent: null
    };
  },
  mounted() {
    window.addEventListener('message', this.messageHandler);
  },
  beforeUnmount() {
    window.removeEventListener('message', this.messageHandler);
  },
  methods: {
    messageHandler(event) {
      const { action } = event.data;
      if (action === 'reloadFrame') {

        this.reloadIFrame();

      }
    },
    reloadIFrame() {
      // Note there are many ways to reload and iframe, which differ in availability
      // by browser and version. This may need to be expanded. 
      const theUrl = this.$refs.iframeref?.src;
      if(theUrl) {
        this.$refs.iframeref.src = theUrl;
      }
    },
  }
}
</script>
